import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { useState, useEffect } from 'react';
import USER_ROLES, { checkRole } from '../constants/roles';

export default function AuthGuard({ children, requiredRole = null }) {
  const { isAuthenticated, isInitialized, user } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  useEffect(() => {
    if (requestedLocation && pathname !== requestedLocation) {
      setRequestedLocation(null);
    }
  }, [pathname, requestedLocation]);

  if (!isInitialized) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    // Encode the pathname to handle special characters
    const encodedPathname = encodeURIComponent(pathname);
    return <Navigate to={`/auth/login?redirect=${encodedPathname}`} />;
  }

  // Si une vérification de rôle est requise
  if (requiredRole) {
    // Vérifier que user et user.role existent avant de les utiliser
    if (!user || !user.role) {
      console.error('User role is missing or undefined');
      return <Navigate to="/auth/login" />;
    }

    // Utiliser la fonction checkRole pour vérifier correctement la hiérarchie des rôles
    const hasRequiredRole = checkRole(user.role, false, requiredRole);

    if (!hasRequiredRole) {
      // Rediriger vers la page appropriée en fonction du rôle
      if (user.role === USER_ROLES.USER) {
        return <Navigate to="/" />;
      } else if (user.role === USER_ROLES.ADMIN) {
        return <Navigate to="/admin/dashboard" />;
      } else {
        return <Navigate to="/auth/login" />;
      }
    }
  }

  // Si l'utilisateur a été redirigé vers la page de connexion et est revenu, le renvoyer vers l'emplacement demandé
  if (requestedLocation && pathname !== requestedLocation) {
    const redirectTo = requestedLocation;
    setRequestedLocation(null);
    return <Navigate to={redirectTo} />;
  }

  return <>{children}</>;
}
